// extracted by mini-css-extract-plugin
export default {"iconContainer":"AssignmentFeed__iconContainer___xWKm0"};